import React from 'react';
import IconButton from '@mui/material/IconButton';
import TableCell from '@mui/material/TableCell';

import {
    formatDateWithoutHours,
    momentZoneToDateAddDays,
    momentZoneToUnix,
} from '../../util/dateUtil';
import './styles.scss';
import { IconComponent, icons } from '../../componets/icons';
import { ColumnDef } from '@tanstack/react-table';
import { useAuth } from '../../context/AuthContext';
import { IFormInputPropsFilter } from '../../componets/interfaces/formInputPropsFilter';
import { FormInputProps } from '../../componets/form/formInterfaces';
import { setHours, setMinutes } from 'date-fns';
import { ImperativeHandleAccessedByParentListComponent } from '../../componets/interfaces/listProps';
import ListComponet from '../../componets/list';
import { IFormSettinsProps } from '../../componets/interfaces/formProps';
import { rowsPerPageOptions } from '../../config';
import api from '../../services/api';

const defaultValues = {
    customer: {
        id: '',
        name: '',
    },
    user: [],
    situation: [],
    dateInitial: momentZoneToDateAddDays({ days: -90, startOfType: 'day' }),
    dateFinal: momentZoneToDateAddDays({ days: 0, endOfType: 'day' }),
    processNumber: '',
    code: '',
};

const AdditionalHonorariumList: React.FC<IFormSettinsProps> = props => {
    const { settings } = props;

    const refForm =
        React.useRef<ImperativeHandleAccessedByParentListComponent>(null);

    const QUERY_DEFAULT = `page=1&limit=${rowsPerPageOptions[0]}`;

    const mainInputsFilter = React.useMemo<FormInputProps[]>(
        () => [
            {
                typeInput: 'text',
                name: 'fileTemplate.description',
                variant: 'standard',
                control: null,
                label: 'Descrição do template',
                size: 'small',
                handleOnKeyPress: (data: any, name?: string) => {
                    if (data.charCode === 13 && name) {
                        refForm?.current?.handleByOnKeyPressEnterNewQuery(
                            data.target.value,
                            name,
                        );
                    }
                },
                md: 12,
                xs: 12,
            },
        ],
        [],
    );

    const inputsFilter: IFormInputPropsFilter[] = [
        {
            typeInput: 'text',
            name: 'fileTemplate.whereUsed',
            variant: 'standard',
            control: null,
            label: 'Onde é usado',
            handleOnKeyPress: (data: any, name?: string) => {
                if (data.charCode === 13 && name) {
                    refForm?.current?.handleByOnKeyPressEnterNewQuery(
                        data.target.value,
                        name,
                    );
                }
            },
        },
    ];

    const downloadTemplate = async (data: any) => {
        const response = await api.get(`${settings.apiPath}/file/${data.id}`, {
            responseType: 'arraybuffer',
        });

        let { originalName, pathFile } = data;
        let arrFileName = [];
        if (originalName) {
            originalName = originalName.replace('.docx', '');
            arrFileName.push(originalName);
        }

        if (pathFile) {
            pathFile = pathFile.replace('.docx', '');
            arrFileName.push(pathFile);
        }

        let fileName = arrFileName.join('-');

        let typeArchive = 'docx';
        const blob = new Blob([response.data], {
            type: `application/${typeArchive}`,
        });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = `${fileName}.${typeArchive}`;
        link.click();
    };

    const columnsTable = React.useMemo<ColumnDef<Object>[]>(
        () => [
            {
                id: 'select',
                header: () => (
                    <TableCell align={'left'} padding={'normal'}>
                        Descrição
                    </TableCell>
                ),
                cell: ({ row }: any) => {
                    return (
                        <TableCell
                            align="left"
                            key={row.id}
                            onClick={() =>
                                refForm?.current?.handleClick(row.original.id)
                            }>
                            {row.original?.description}
                        </TableCell>
                    );
                },
            },
            {
                id: 'select',
                header: ({ table }: any) => <TableCell align="center" />,
                cell: ({ row }: any) => (
                    <TableCell align="right">
                        <IconButton
                            onClick={() => downloadTemplate(row.original)}>
                            <IconComponent icon={icons.Visibility} />
                        </IconButton>
                        <IconButton
                            onClick={() =>
                                refForm?.current?.handleEdit(row.original.id)
                            }>
                            <IconComponent icon={icons.ModeEdit} />
                        </IconButton>
                        <IconButton
                            onClick={() => {
                                refForm?.current?.setIdDelete(row.original.id);
                                refForm?.current?.setOpenModalDelete(true);
                            }}>
                            <IconComponent icon={icons.Delete} />
                        </IconButton>
                    </TableCell>
                ),
            },
        ],
        [],
    );

    return (
        <ListComponet
            settings={settings}
            defaultValues={defaultValues}
            columnsTable={columnsTable}
            inputsFilter={inputsFilter}
            mainInputsFilter={mainInputsFilter}
            QUERY_DEFAULT={QUERY_DEFAULT}
            ref={refForm}
            inactiveFilterClean={true}
        />
    );
};
export default AdditionalHonorariumList;
